import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';

import { editEstimateById, estimate, getAssociatedCharges, getCPTS, getDXCodes, getEstimateById, getRevenueCodes, setClaimChargeMode, setClaimEstimatorCharges, getCPTSV2,CLAIM_ANALYSIS_RESET_CPTS  } from '../../store/actions/claimAnalysis';
import { getTinyContractsByState } from '../../store/actions/contracts';
import { set } from '../../store/actions/pages';
import { CONTRACTED_SERVICE_OUTPATIENT } from '../../store/constants/contract';
import { selectTinyContractsByState } from '../../store/selectors/contracts';
import { asIsoDate } from '../../util/date';
import { createListField, createPlainDateField, createStringDataField,createIconDataField,createCurrencyDataField } from '../../util/format';
import { createFilteredSortedDataSelector } from '../../util/selector';
import ClaimEstimatorComponent from './ClaimEstimatorPage';
import { selectPayerIdMappingFlag } from "../../store/selectors/settings";
import { getPayerIdMappingTiny } from "../../store/actions/payers";
import { payerIdMappingLanding } from "../../store/actions/pages";
import { getFacilityBranding } from "../../store/actions/clients";
import { list as getFacilities } from '../../store/actions/facilities';
import { selectFacilityList } from '../../store/selectors/facilities';

export const ClaimEstimator = connect(
    () => {

        const DEFAULT_SORT = [{ id: 'name', orderBy: 'asc' }];

        const selectMode = (state, props) => props.match.params.estimatorId === 'new' ? 'create' : 'edit';
        const selectEstimatorId = (state, props) => props.match.params.estimatorId;
        const selectDXCodes = (state) => state.claimAnalysis.dxCodes;

        const selectClaimChargeData = (state) => state.claimAnalysis.claimChargeData;
        const selectClaimChargeMode = (state) => state.claimAnalysis.claimChargeMode;
        const selectClaimChargeIndex = (state) => state.claimAnalysis.claimChargeIndex;
        const selectEstimateById = (state) => state.claimAnalysis.estimateById;
        const selectPayerMappingIdsTiny = (state) => state.payers.payerIdMappingTiny;
        const selectFacilities = selectFacilityList;

        const selectFields = createSelector(
            () => [
                createStringDataField('associatedChargeDescription', 'Service', { sortable: false, primary: true, iconWithText: true }),
                createStringDataField('cpt', 'Procedure (CPT)', { sortable: true, onHover: true, primary: true }),
                createStringDataField('revCode', 'Rev Code', { sortable: true, onHover: true, primary: true }),
                createStringDataField('units', 'Units', { primary: true }),
                createCurrencyDataField('perUnitCharge', 'Per Unit Charge Amount', { primary: true }),
                createCurrencyDataField('totalCharges', 'Total Charge Amount', { primary: true })
            ]
        );

        const selectPayerIdFields = createSelector(
        selectTinyContractsByState,
            (tinyContracts) => [
                createStringDataField('payerName', 'Payer Name', { sortable: true, whiteSpace: 'break-spaces' }),
                createStringDataField('payerId', 'Payer ID', { sortable: true, whiteSpace: 'break-spaces' })
            ]
    );

        const selectFilteredFields = createSelector(
            selectFields,
            (fields) => {
                return fields.map(field => field.id);
            }
        );

        const selectSort = createSelector(
            (state) => state.pages['claim-estimator-landing'].sort,
            (sort) => sort || DEFAULT_SORT,
        );

        const selectFilteredData = createFilteredSortedDataSelector(
            selectFilteredFields,
            (state) => state.pages['claim-estimator-landing'].filter,
            selectSort,
            selectClaimChargeData,
        );

        const selectSortedTinyContracts = createSelector(selectTinyContractsByState,
            (contracts) => {
                return contracts.sort((a, b) => a.name.localeCompare(b.name))
            }
        );
        const selectPayerIdData = createSelector(
            (state) => state.pages['payer-id-mapping-landing'].list,
            (data) => {
                return data
            }
        );


        function orderCharges(data) {
            if(!data || data.length === 0) return []
            // Check if any item has displayGridKey property is null it means no grouping needed it is legacy data need to return as is
            const hasNullDisplayGridKey = data.filter(item => item.displayGridKey === null || item.displayGridKey === undefined);
            if (hasNullDisplayGridKey.length > 0) {
                return data;
            }
            // Group all charges by displayGridKey
            const grouped = data.reduce((acc, item) => {
                const key = item.displayGridKey || item.primaryId;
                if (!acc[key]) acc[key] = [];
                acc[key].push(item);
                return acc;
            }, {});

            const ordered = [];

            // Traverse through each group
            for (const key in grouped) {
                const group = grouped[key];
                // Find parent
                const parent = group.find(item => item.isPrimaryCpt === true);
                if (parent) {
                ordered.push(parent);
                // Find children and append
                const children = group.filter(item => item.isPrimaryCpt === false);
                ordered.push(...children);
                }
            }

            return ordered;
            }


        const selectInitialValues = createSelector(
            selectMode,
            selectEstimateById,
            selectDXCodes,
            selectPayerIdMappingFlag,
            selectFacilities,
            (mode, estimateById, dxCodes,payerIdMappingSettingsFlag,facilities) => {
                if (mode === 'edit' && estimateById) {
                    return {
                        claimType: estimateById.claimType,
                        contractId: estimateById.contract,
                        facilityId: estimateById.facilityId || null,
                        estimatorPayerId: estimateById.estimatorPayer, 
                        isPayerId: estimateById.estimatorPayer ? true : false,
                        drg: null,
                        claimAmount: estimateById.claimAmount,
                        principalDX: { code: estimateById.principalDX, description: '' },
                        admitionDate: asIsoDate(estimateById.admitionDate),
                        dischargeDate: '',
                        patientFName: estimateById.patientFName,
                        isSelfPayEnabled: estimateById.isSelfPayEnabled ?? false,
                        patientLName: estimateById.patientLName,
                        placeOfServiceCode: estimateById.placeOfServiceCode,
                        dxInputValue: '',

                        charges: {
                            modifierField: '',
                            modifiers: [],
                            associatedCharges: [],

                            cpt: null,
                            cptDescription: '',
                            revCodeDescription: '',
                            revCode: '',
                            chargeAmount: '',
                            totalClaimAmount: '',
                            associatedCharge: '',
                            units: '1',
                            serviceDate: asIsoDate(new Date()),

                            cptInputValue: ''
                        }
                    }
                }
                return {
                    claimType: CONTRACTED_SERVICE_OUTPATIENT,
                    contractId: null,
                    facilityId: facilities && facilities.length > 0 ? facilities[0].id : null, // Change this line
                    estimatorPayerId: null, 
                    isPayerId: payerIdMappingSettingsFlag ? true : false,
                    drg: null,
                    claimAmount: '0',
                    principalDX: null,
                    admitionDate: asIsoDate(new Date()),
                    dischargeDate: '',
                    patientFName: '',
                    patientLName: '',
                    isSelfPayEnabled: false,
                    dxInputValue: '',
                    placeOfServiceCode: null,

                    charges: {
                        modifierField: '',
                        modifiers: [],
                        associatedCharges: [],
                        cpt: null,
                        cptDescription: '',
                        revCodeDescription: '',
                        revCode: '',
                        chargeAmount: '',
                        associatedCharge: '',
                        units: '1',
                        serviceDate: asIsoDate(new Date()),

                        cptInputValue: ''
                    }
                }

            }
        )

        return (state, props) => ({
            estimatorMode: selectMode(state, props),
            estimationId: selectEstimatorId(state, props),
            estimateById: selectEstimateById(state),

            initialValues: selectInitialValues(state, props),
            mode: selectClaimChargeMode(state),
            selectedClaimChargeIndex: selectClaimChargeIndex(state),
            cptCodes: state.claimAnalysis.cptCodes,
            revenueCodes: state.claimAnalysis.revenueCodes,
            associatedCharges: state.claimAnalysis.associatedCharges,
            tinyContracts: selectSortedTinyContracts(state),

            getAssociatedChargesPending: state.claimAnalysis.getAssociatedCharges.pending,
            getCPTCodesPending: state.claimAnalysis.getCPTCodes.pending,

            estimatePending: state.claimAnalysis.estimateClaim.pending,
            editEstimatePending: state.claimAnalysis.editEstimateById.pending,
            getEstimatePending: state.claimAnalysis.getEstimateById.pending,
            brandingDetails: state.clients.facilityBranding,
            getBrandingPending: state.clients.getFacilityBranding.pending,

            dxCodes: selectDXCodes(state),
            dxCodesPending: state.claimAnalysis.getDXCodes.pending,

            fields: selectFields( state as never),
            claimChargeData: orderCharges(selectFilteredData(state)),
            payerIdData:selectPayerIdData(state),
            sort: selectSort(state),
            order: state.pages['claim-estimator-landing'].order,
            filter: state.pages['claim-estimator-landing'].filter,
            payerIdMappingSettingsFlag: selectPayerIdMappingFlag(state),
            payerIdMappingsTiny: selectPayerMappingIdsTiny(state),
            payerIdFields:selectPayerIdFields(state),
            facilities: selectFacilities(state)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getCPTS: getCPTSV2,
            resetCPTCodes: () => ({
                type: CLAIM_ANALYSIS_RESET_CPTS
            }),
            getRevenueCodes: getRevenueCodes,
            getTinyContractsByState: getTinyContractsByState,
            getAssociatedCharges: getAssociatedCharges,
            setFilter: (value) => set('claim-estimator-landing', 'filter', value),
            setOrder: (value) => set('claim-estimator-landing', 'order', value),
            setSort: (value) => set('claim-estimator-landing', 'sort', value),
            setClaimEstimatorCharges: setClaimEstimatorCharges,
            estimate: estimate,
            setClaimChargeMode: setClaimChargeMode,
            getEstimateById: getEstimateById,
            editEstimateById: editEstimateById,
            getDXCodes: getDXCodes,
            getFacilityBranding: getFacilityBranding,
            getPayerIdMappingTiny: getPayerIdMappingTiny,
            payerIdMappingLanding:payerIdMappingLanding,
            getFacilities: getFacilities,
        }, dispatch)
    })
)(injectIntl(ClaimEstimatorComponent));
